import React from "react";
import { Reveal, RevealStagger, StaggerItem } from "@/components/Reveal";
import { STATS } from "@/data/content";

const StatsStrip = () => {
  return (
    <section data-testid="stats-strip" className="relative bg-slate-50 py-16 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <Reveal className="mb-10">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand">Verified credentials</p>
          <h2 className="font-heading font-extrabold text-[#0b2c4d] text-2xl md:text-3xl tracking-tight mt-2">
            Evidence-based care, transparently presented
          </h2>
        </Reveal>

        <RevealStagger className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {STATS.map((s) => (
            <StaggerItem key={s.label}>
              <div className="glass-card rounded-2xl p-6 h-full hover:-translate-y-1 hover:shadow-lg transition-all duration-300">
                <div className="font-heading font-extrabold text-brand text-3xl md:text-4xl tracking-tight">
                  {s.value}
                </div>
                <div className="mt-2 text-[#0b2c4d] font-semibold text-sm">{s.label}</div>
                <div className="text-slate-500 text-xs mt-1">{s.sub}</div>
              </div>
            </StaggerItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};

export default StatsStrip;
